<template>
  <CardedForm
    ref="review_business_form_ref"
    id="review_business_form"
    title="_"
    :is_loading="is_loading || is_owner || is_in_admin_view == true"
    @on-submit-form="submit"
    :errors="errors"
    :message="message"
    @on-auto-fill="on_auto_fill"
    @on-close-message="on_hide_message"
    @on-clear-form="on_form_cleared"
  >
    <v-alert dense text type="warning" v-if="is_owner && is_in_admin_view == false">
      Please note that you <strong> can not review your own business</strong>
    </v-alert>

    <v-alert
      dense
      text
      type="warning"
      v-if="(!is_owner || is_in_admin_view == true) && previous_review.length > 0"
    >
      You previously reviewed this business
      <strong>{{ previous_review }}</strong>
    </v-alert>
    <TextField
      v-model="form.comment"
      :validation_rules="form_validations.comment"
      label="Type a comment"
      icon="mdi-pen-plus"
      :disabled="is_owner || is_loading || is_in_admin_view == true"
    ></TextField>
    <br />
  </CardedForm>
</template>

<script>
import CardedForm from "./../components/CardedForm";
import TextField from "./../components/TextField";
import ServerClient from "./../lib/ServerClient";
import Utils from "./../lib/Utils";
export default {
  name: "BusinessViewReviewForm",
  components: {
    CardedForm,
    TextField,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner: {
      type: Boolean,
      default: false,
    },
    business: {
      type: Object,
      default: function () {
        return Utils.get_default_business();
      },
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
    // user: {
    //   type: Object,
    //   default: function () {
    //     return null;
    //   },
    // },
  },
  data: function () {
    return {
      errors: [],
      message: "",
      form: {
        comment: "",
      },
      form_validations:{
          comment:[]
      },
      user: null
    };
  },
  methods: {
    on_auto_fill() {
      var rnd = Math.ceil(Math.random() * 6);
      this.form.comment = "This is a nice business, and i love it to be cool ";
      this.errors = [];
      this.message = "";
    },
    init_form() {
      this.form.comment = "";
      this.errors = [];
      this.message = "";
    },
    on_form_cleared() {
      this.init_form();
    },
    submit() {
      
      if (
        this.user == null ||
        this.user == undefined ||
        parseInt(this.user.id) == 0
      ) {
        ServerClient.set_temp_review(this.form.comment);
        this.$emit("on-not-loggedin", this.form.comment);
        return false;
      }
      this.errors = [];
      this.message = "";
      this.$emit("on-show-loader");
      ServerClient.Businesses.post_business_review(
        {
          ...this.form,
          business_id: this.business.id,
          user_id: this.user.id
        },
        (res) => {
          //console.log("Items ", res);
          this.items = res;
          this.$refs.review_business_form_ref.on_clear_form();
          this.init_form();
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  Thank you <b>" +
            this.user.first_name +
            " " +
            this.user.last_name +
            "</b> for reviewing this business ";
          this.$refs.review_business_form_ref.show_message_dialog();
        },
        (errors) => {
          this.errors = errors;
          this.$refs.review_business_form_ref.show_error_dialog();
          this.$emit("on-hide-loader");
        }
      );
    },
    on_hide_message() {
      this.$emit("on-success-reviewed");
    },
  },
  computed: {
    previous_review() {
      var prev = -1;
      if (
        this.business &&
        this.business.reviews &&
        this.business.reviews.length > 0 &&
        this.user != null
      ) {
        for (var index = 0; index < this.business.reviews.length; index++) {
          var review = this.business.reviews[index];
          if (parseInt(review.user_id) == parseInt(this.user.id)) {
            prev = review.comment;
            break;
          }
        }
      }
      return prev;
    },
  },
  mounted() {
      this.user = ServerClient.Login.get_logged_in_user();
    var temp_review = ServerClient.get_temp_review();
    var get_has_just_review_logged_in = ServerClient.get_has_just_review_logged_in();
    // console.log(
    //   "get_has_just_review_logged_in: ",
    //   get_has_just_review_logged_in,
    //   temp_review,
    //   this.is_owner,
    //   this.user
    // );
    
    ServerClient.clear_temp_review();
    if (
      get_has_just_review_logged_in == "true" &&
      this.user &&
      this.user != null &&
      parseInt(this.user.id) > 0 &&
      this.is_owner == false
    ) {
      //we can auto post for this user the comment
      this.form.comment = temp_review;
      this.submit();
    }
  },
};
</script>